const controllingPersonTypes = [
  { key: 1, value: 'Legal person: ownership', rcFormValue: 'Direct owner of a corporation or other legal person' },
  { key: 2, value: 'Legal person: other means', rcFormValue: 'Indirect owner of a corporation or other legal person (through an intermediary)' },
  { key: 3, value: 'Legal person: snr. managing official', rcFormValue: 'Director or senior official of a corporation or other legal person' },
  { key: 4, value: 'Trust: settlor', rcFormValue: 'Settlor of a trust' },
  { key: 5, value: 'Trust: trustee', rcFormValue: 'Trustee of a trust' },
  { key: 6, value: 'Trust: protector', rcFormValue: 'Protector of a trust' },
  { key: 7, value: 'Trust: beneficiary', rcFormValue: 'Beneficiary of a trust' },
  { key: 8, value: 'Trust: other', rcFormValue: 'Other controlling person of a trust' },
  { key: 9, value: 'Other: settlor-equivalent', rcFormValue: 'Equivalent to a settlor of a legal arrangement other than a trust (e.g. partnership)' },
  { key: 10, value: 'Other: trustee-equivalent', rcFormValue: 'Equivalent to a trustee of a legal arrangement other than a trust (e.g. partnership)' },
  { key: 11, value: 'Other: protector-equivalent', rcFormValue: 'Equivalent to a protector of a legal arrangement other than a trust (e.g. partnership)' },
  { key: 12, value: 'Other: beneficiary-equivalent', rcFormValue: 'Equivalent to a beneficiary of a legal arrangement other than a trust (e.g. partnership)' },
  { key: 13, value: 'Other: other-equivalent', rcFormValue: 'Other controlling person of a legal arrangement other than a trust (e.g. partnership)' }
];

controllingPersonTypes.findByKey = (key) => {
  if (!key || key <= 0) {
    return null;
  }

  const code = controllingPersonTypes.find(x => x.key === key);
  return code && code.value ? code.value : null;
};

controllingPersonTypes.mapRcFormValueToCpValue = (rcFormValue) => {
  if (!rcFormValue || rcFormValue === '') {
    return null;
  }

  const code = controllingPersonTypes.find(x => x.rcFormValue === rcFormValue);
  return code && code.value ? code.value : null;
};

export default controllingPersonTypes;
